module.exports = __webpack_public_path__ + "static/media/call_status_answered.37df5555.svg";